export default __webpack_public_path__ + "static/media/bg-map2.7aaf1756.png";